import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
import { getClientId } from '../../utils/config';
export { ssoLogin };
var ssoLoginQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query SsoLogin($client: String!, $provider: SsoProviders!, $email: String!, $token: String!) {\n    ssoTokens(clientId: $client, provider: $provider, email: $email, providerToken: $token) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n    }\n  }\n"])));
function ssoLogin(_x, _x2, _x3) {
  return _ssoLogin.apply(this, arguments);
}
function _ssoLogin() {
  _ssoLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(provider, email, token) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return wrapQuery('ssoLogin', ssoLoginQuery, {
            client: getClientId(),
            provider: provider,
            email: email,
            token: token
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.ssoTokens.tokens);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ssoLogin.apply(this, arguments);
}